import React from "react";
import "./checkbox.css";

const Checkbox = ({ name, checked = false, onChange, number }) => (
  <div className="checkbox">
    <input
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
      id={name}
    />
    <label htmlFor={name}>{name}</label>
  </div>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./src/NavBar/SelectDialog/Checkbox.js